import { http } from "@/lib/api";
import { getSessionId } from "@/lib/abtest";

/**
 * Fire-and-forget sponsor analytics. Backend dedupes impressions per
 * (session, company, surface, day) so repeated scrolls don't inflate counts.
 *
 * @param {"global_footer"|"event_main_banner"|"table_card"} surface
 */
export function recordSponsorImpression(surface, { company, sponsorship_id, event_id, table_id } = {}) {
  if (!company) return;
  const session_id = getSessionId();
  http.post("/sponsor-impressions", {
    session_id, company, surface,
    sponsorship_id: sponsorship_id || undefined,
    event_id: event_id || undefined,
    table_id: table_id || undefined,
  }).catch(() => { /* fire-and-forget */ });
}

export function recordSponsorClick(surface, { company, sponsorship_id, event_id, table_id } = {}) {
  if (!company) return;
  const session_id = getSessionId();
  http.post("/sponsor-clicks", {
    session_id, company, surface,
    sponsorship_id: sponsorship_id || undefined,
    event_id: event_id || undefined,
    table_id: table_id || undefined,
  }).catch(() => { /* fire-and-forget */ });
}

/** Fired when the SponsorMomentModal opens. Idempotent per session+company+day. */
export function recordSponsorMomentOpen({ company, sponsorship_id, event_id, table_id } = {}) {
  if (!company) return;
  const session_id = getSessionId();
  http.post("/sponsor-moment/open", {
    session_id, company,
    sponsorship_id: sponsorship_id || undefined,
    event_id: event_id || undefined,
    table_id: table_id || undefined,
  }).catch(() => { /* fire-and-forget */ });
}

/** Fired on modal close OR every 5s while playing. Sends the highest watched. */
export function recordSponsorMomentProgress({ company, sponsorship_id, event_id, table_id, watched_seconds, total_seconds } = {}) {
  if (!company || !Number.isFinite(watched_seconds)) return;
  const session_id = getSessionId();
  http.post("/sponsor-moment/progress", {
    session_id, company,
    sponsorship_id: sponsorship_id || undefined,
    event_id: event_id || undefined,
    table_id: table_id || undefined,
    watched_seconds: Math.max(0, watched_seconds),
    total_seconds: Math.max(0, total_seconds || 0),
  }).catch(() => { /* fire-and-forget */ });
}
